module.exports = __webpack_public_path__ + "static/img/mzhongHuai.148eefb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/mzhongHuai.png
// module id = IuLe
// module chunks = 0